import { Component } from '@angular/core';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [TestIdDirective],
    template: `<div camTestId="smoke-ok">harness smoke ok</div>`
})
export class SmokeCase {}
